<template>
    <div class="container-fluid wiagro_login wiagro_login--background">
        <div class="row">
            <div class="container">
                <div class="d-flex justify-content-center align-items-center min-vh-100">
                    <w-card size="30">
                        <div class="row">
                            <div class="col-12 text-center mb-2 mt-2">
                                <img src="../assets/images/logo_new_altium_png.png" class="img-fluid" alt="wiagro logo"/>
                            </div>
                            <div class="col-12 text-center">
                                <div class="font-weight-bold">Smart SiloBag</div>
                                <h1>{{$t('LOGIN.WELCOME')}}</h1>
                                <el-form
                                        :ref="FORM_NAME"
                                        :model="form"
                                        hide-required-asterisk
                                        :rules="rules"
                                        status-icon
                                        onsubmit="return false"
                                >
                                    <el-form-item prop="username">
                                        <el-input v-model="form.username" :placeholder="$t('LOGIN.USERNAME')">
                                            <i slot="prefix" class="el-input__icon el-icon-user"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="password">
                                        <el-input v-model="form.password" :placeholder="$t('LOGIN.PASSWORD')"
                                                  type="password" show-password>
                                            <i slot="prefix" class="el-input__icon el-icon-key"></i>
                                        </el-input>
                                    </el-form-item>
                                    <span class="text-danger">{{error}}</span>
                                    <el-form-item align="right">
                                        <el-button
                                                type="primary"
                                                class="w-100 mt-1"
                                                round
                                                @click="login"
                                                native-type="submit"
                                                :loading="loginInProcess"
                                        >{{$t('LOGIN.SIGN_IN')}}
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </w-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import wCard from "../components/common/wCard.vue";
    import api from "../utils/api/api.js";
    import routesNames from "../utils/router/routesNames";
    import mutations from "../utils/store/mutations";
    import storeLoader from "../utils/storeLoader";

    export default {
        name: "login",
        components: {
            "w-card": wCard
        },

        data: function () {
            return {
                FORM_NAME: "loginForm",
                form: {
                    username: undefined,
                    password: undefined
                },
                rules: {
                    username: [
                        {required: true, message: this.$t("LOGIN.USERNAME_REQUIRED")}
                    ],
                    password: [
                        {required: true, message: this.$t("LOGIN.PASSWORD_REQUIRED")}
                    ]
                },
                loginInProcess: false,
                error: undefined
            };
        },
        mounted: function () {
        },
        methods: {
            login: function () {
                this.$refs[this.FORM_NAME].validate(valid => {
                    if (valid) {
                        this.loginInProcess = true;

                        // test1 yRH8WxW0
                        // test2 SnafeiFX
                        // test3 1xaMwUNK
                        // hack2in  d3moWs
                        // creamaster Sup3rCre2M2st3r
                        // const user = {
                        //     username: "hack2in",
                        //     password: "d3moWs"
                        // };
                        //                            .login("liagmaster", "Sup3rLi2g")

                        api
                            .login(this.form.username, this.form.password)
                            // .login("hack2in", "d3moWs")
                            .then(value => {
                                this.$store.commit(mutations.SAVE_TOKEN, value.register.token);
                                this.$store.commit(mutations.SAVE_USER, value.register.userdata);
                                storeLoader.load();
                                this.$router.push({name: routesNames.DASHBOARD});
                            })
                            .catch(reason => {
                                this.error = this.$t("ERROR." + reason.code);
                            })
                            .finally(() => {
                                this.loginInProcess = false;
                            });
                    }
                });
            }
        }
    };
</script>

<style scoped>


</style>